export default __webpack_public_path__ + "static/media/Novelties_Orange.e405d04c.svg";